import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import BrandLogo from './brand/BrandLogo';
import { FiActivity, FiUsers, FiTarget, FiCheckSquare, FiSettings, FiInfo } from 'react-icons/fi';

const navItems = [
  { path: '/', icon: FiActivity, label: 'Signal Map' },
  { path: '/accounts', icon: FiUsers, label: 'Accounts' },
  { path: '/playbooks', icon: FiTarget, label: 'Playbooks' },
  { path: '/demo-center', icon: FiInfo, label: 'Overview & FAQ' },
  { path: '/settings', icon: FiSettings, label: 'Settings' },
];

const Sidebar = () => {
  return (
    <aside className="w-64 h-screen bg-[#0a0a0f] border-r border-white/5 flex flex-col pt-8 hidden md:flex z-20 sticky top-0 overflow-hidden">
      <div className="px-6 mb-10 flex items-center gap-3">
        <BrandLogo size="md" />
        <span className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-violet-400 to-emerald-400 tracking-tight">
          ChurnSignal
        </span>
      </div>

      <nav className="flex-1 px-4 space-y-1.5 overflow-y-auto custom-scrollbar">
        <p className="px-4 text-[10px] font-bold text-slate-600 uppercase tracking-widest mb-4">Command Center</p>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 group ${
                isActive
                  ? 'bg-violet-500/10 text-violet-400 border border-violet-500/20 shadow-[0_0_15px_rgba(139,92,246,0.1)]'
                  : 'text-slate-400 hover:text-slate-200 hover:bg-white/5 border border-transparent'
              }`
            }
          >
            <SafeIcon icon={item.icon} className="text-lg group-hover:scale-110 transition-transform" />
            <span className="font-medium text-sm">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-white/5">
        <div className="bg-[#13131a] rounded-xl p-4 border border-white/5">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse shadow-[0_0_8px_rgba(16,185,129,0.8)]"></div>
            <span className="text-[10px] text-emerald-400 font-bold uppercase tracking-wider">Live Telemetry</span>
          </div>
          <p className="text-[11px] text-slate-500 leading-tight">
            Monitoring 142 accounts across 4 key segments.
          </p>
        </div>
        <div className="mt-4 text-center">
            <p className="text-[10px] text-slate-600 flex items-center justify-center gap-1">
              <BrandLogo size="sm" className="scale-50 opacity-40" /> 
              Made by LingLink AI & DigLab AI
            </p>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;